<template>
	<div>
		<div class="result_xmp">【{{answer.genre_text}}】{{answer.title}}</div>
		<div>
			<div class="select_box" v-if="multipleChoiceQuestions.includes(answer.genre)">
				<!-- 单选题 -->
				<div class="option" v-for="(answer2,index2) in answer.option_name" :key="index2">
					<div class="option_key"
						:class="aaaa(answer).jg=='yes' && answer.user_answer == index2 ?'succoption_key':aaaa(answer).jg=='no' && answer.user_answer == index2?'erroption_key':aaaa(answer).jg=='no' && answer.answer == index2?'succoption_key':''">
						{{index2}}
					</div>
					<div class="option_name"
						:class="aaaa(answer).jg=='yes' && answer.user_answer == index2 ?'succoption_name':aaaa(answer).jg=='no' && answer.user_answer == index2?'erroption_name':aaaa(answer).jg=='no' && answer.answer == index2?'succoption_name':''">
						{{answer2}}
					</div>
				</div>
				<div class="option">
					<div class="option_key" :class="aaaa(answer).jg=='no' && answer.user_answer == '不会'?'erroption_key':''">?</div>
					<div class="option_name"  :class="aaaa(answer).jg=='no' && answer.user_answer == '不会'?'erroption_name':''">不会</div>
				</div>
			</div>
			<!-- 多选题start -->
			<div class="select_box" v-if="multipleChoicesQuestions.includes(answer.genre)">
				<div class="option" v-for="(answer2,index2) in answer.option_name" :key="index2">
					
					<div class="option_key"
						:class="answer.user_answer.includes(index2)&& !answer.answer.includes(index2)? 
									'erroption_key':answer.user_answer.includes(index2) &&  answer.answer.includes(index2)?
										'sueroption_key':answer.answer.includes(index2)?
														'succoption_key':''">
						{{index2}}
					</div>
					<div class="option_name"
						:class="answer.user_answer.includes(index2)&& !answer.answer.includes(index2) ? 'erroption_name':answer.user_answer.includes(index2) &&  answer.answer.includes(index2)?'succoption_name':answer.answer.includes(index2)?'succoption_name':''">
						
						{{answer2}}
						
					</div>
				</div>
				<div class="option">
					<div class="option_key" :class="aaaa(answer).jg=='no' && answer.user_answer == '不会'?'erroption_key':''">?</div>
					<div class="option_name"  :class="aaaa(answer).jg=='no' && answer.user_answer == '不会'?'erroption_name':''">不会</div>
				</div>
			</div>
		</div>
		<!-- 查看解析 -->
		<div class="analysis" v-if="isAnalysis == false">
			<div class="analysis_title">
				<div></div>
				<div class="btns">
					<div style="margin-right: 30px;color: #ff6c6c;">全站正确率：{{answer.right_rate}}%</div>
					<div class="btn" @click="showWrongWin = true">
						<img src="../../public/images/an_6.png">
						纠错
					</div>
					<div class="btn" @click="()=>{isAnalysis = true;getPageNote()}">
						<img src="../../public/images/an_4_h.png">
						展开解析
					</div>
					<div class="btn" @click="collectClick">
						<img src="../../public/images/an_9.png" v-if="answer.collect == 0">
						<img src="../../public/images/an_9_h.png" v-if="answer.collect == 1">
						收藏
					</div>
				</div>
			</div>
		</div>
		<div class="analysis" v-if="isAnalysis == true">
			<div class="analysis_title zhankai">
				<div>
					<span>解析</span>
					<span style="margin-left: 20px;">正确答案：<span class="succoption_name">{{answer.answer}}</span></span>
					<span style="margin-left: 20px;">你的答案：<span
							:class="answer.answer != answer.user_answer?'erroption_name':'succoption_name'">{{answer.user_answer}}</span></span>
				</div>
				<div class="btns">
					<div style="margin-right: 30px;color: #ff6c6c;">全站正确率：{{answer.right_rate}}%</div>
					<div class="btn" @click="showWrongWin = true">
						<img src="../../public/images/an_6.png">
						纠错
					</div>
					<div class="btn" @click="isAnalysis = false">
						<img src="../../public/images/an_4_h.png">
						收起解析
					</div>
					<div class="btn" @click="collectClick">
						<img src="../../public/images/an_9.png" v-if="answer.collect == 0">
						<img src="../../public/images/an_9_h.png" v-if="answer.collect == 1">
						收藏
					</div>
				</div>
			</div>
			<div class="analysis_content" v-html="answer.analysis">

				
			</div>

			<div class="answer-note">
				<div class="parsing-title">本题笔记</div>
				<aside>
					<p>
						<textarea placeholder="请输入笔记内容" rows="3" v-model="noteValue"></textarea>
					</p>
					<el-button type="primary" size="small" @click="setUserNote()">保存</el-button>
				</aside>

				<div class="answer-note-list">
					<div class="note-list" v-for="item in noteList" :key="item.id">
						<div class="note-list-tit">
							<div class="note-list-photo">
								<el-avatar :size="50" :src="item.image"></el-avatar>
							</div>
							<div class="note-list-info">
								<p style="margin-top:4px">{{item.nickname}}</p>
								<p>{{item.create_time}}</p>

							</div>
				
							
							<div style="   flex: 1;  text-align: right;line-height:48px;">
								<button class="note-list-praise" 
								@click=" zannote(item.id,$event)">{{item.praise}}</button>
								<button class="note-list-dete" v-show="userid == item.user_id" title="删除"
								@click="sun(item.id)">删除 </button>
							</div>	
					
						
						
						</div>
						<div class="note-list-text">{{item.content}}</div>
					</div>
					<button class="answer-list-more" @click="getMoreNote()">加载更多笔记</button>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="showWrongWin" width="480px">
			<div class="win-wrong">
				<h3>纠错</h3>
				<el-form>
					<el-form-item>
						<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容" maxlength="200"
							show-word-limit></el-input>
					</el-form-item>
					<el-button type="primary" @click="errorCorrection()" style="margin:0;font-size: 16px;color: #fff;">
						确认</el-button>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: ['answer', 'index', 'type', 'ques_id'],
		data() {
			return {
				userid:'',
				multipleChoiceQuestions: [
					1,
					3,
					4,
					5,
					7,
					8,
					9,
					1001,
					1003,
					1004,
					1101,
					1104,
					1201,
					1301,
					1304,
				], //单选题题型
				isAnalysis: false,
				noteValue: '',
				multipleChoicesQuestions: [2, 1002, 1102, 1302], //多选题题型
				fillInTheBlankQuestionType: [6, 1206], //填空题题型
				shortAnswerQuestionType: [4, 5, 7, 8, 9, 1004, 1104, 1304], //简答题题型
				selectArr: [], //多选题储存选中选项的索引值
				cwArr: [],
				zqArrs: [],
				showWrongWin: false,
				wrongValue: '',
				noteList: [],
			}
		},
	created() {
			//console.log("进入")
			this.userid = localStorage.getItem('userId')
			
			if (this.multipleChoicesQuestions.includes(this.answer.genre)) {
				let bt = this.getArrDifference(this.answer.answer, this.answer.user_answer) //找到并提取两个字符串中不同的地方并返回数组
	 			for (let i in this.answer.option_name) {
					for (let j in bt) {
						if (i == bt[j]) {
							this.cwArr.push(i) //找出两个数组相同的
							console.log(this.cwArr)
						}
					}
				}
				let xt = this.getSome(this.answer.answer, this.answer.user_answer) //相同
				for (let i in this.answer.option_name) {
					for (let j in xt) {
						if (i == xt[j]) {
							this.selectArr.push(i) //找出两个数并提取索引值
						}
					}
				}
				this.zqArrs = this.selectArr.filter(res => {
					//console.log(res)
					return this.cwArr.indexOf(res)
				})
				console.log(this.index + '、', 'zqArr' + this.zqArrs, 'cwArr' + this.cwArr, 'selectArr' + this.selectArr)
			}
			
		},
		methods: {
			zannote(id){
					this.$api.userNotePraise({id:id}).then((res)=>{
							this.getPageNote()			
							//console.log(res)
					})	
	
			}
			,
			sun(id_){
			
				this.$confirm('您确定要删除笔记吗？?', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }) .then(() => {
						this.$api.delUserNote({id:id_})
						.then((res)=>{
								this.getPageNote()
						})
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });









			},
			getArrDifference(arr1, arr2) {
				if (arr2) {
					arr1 = arr1.split('')
					arr2 = arr2.split('')
					return arr1.concat(arr2).filter(function(v, i, arr) {
						return arr.indexOf(v) === arr.lastIndexOf(v);
					});
				}
			},
			errorCorrection() { //纠错
				this.$api.setCorrection({
					list_id: this.answer.list_id,
					content: this.wrongValue
				}).then(res => {
					this.$message.success('感谢你的支持,小莘会尽快审核修改!')
					this.showWrongWin = false
					this.wrongValue = ''
					//console.log(res)
				})
			},
		
			getPageNote() {
				//console.log(1)
				//list_id	是	string	试题id
				this.$api.getPageNote({
					list_id: this.answer.list_id,
					page: 1,
					limit: 10
				}).then(res => {
					//console.log(res)
					this.noteList = res.data
				})
			},
			collectClick() {
				//console.log(12312)
				this.$api.setUserCollect({
					list_id: this.answer.list_id,
					sub_id: this.ques_id,
					type: this.type
				}).then(res => {
						
					if (this.answer.collect == 0) {
						this.$message.success('本小题收藏成功')
						this.$emit('collect', {
							index: this.index,
							type: 'yes'
						})
					} else {
						this.$message.success('取消收藏成功')
						this.$emit('collect', this.index)

						this.$emit('collect', {
							index: this.index,
							type: 'no'
						})
					}

				})
			},
			setUserNote() {
				//list_id	是	string	试题id
				//type	是	string	1专项 2随机 3试卷
				//sub_id	否	string	type=1属于分类小节id，type=2无，type=3属于试卷id
				this.$api.setUserNote({
					list_id: this.answer.list_id,
					sub_id: this.ques_id,
					content: this.noteValue,
					type: this.type,
				}).then(res => {
					//console.log("res")
					//console.log(res)
					this.$message.success('添加笔记成功')
					this.noteValue = ''
					this.getPageNote()
				})
			},
			getSome(arr1, arr2) {
				if (arr2) {
					arr1 = arr1.split('')
					arr2 = arr2.split('')
					let newArr = [];
					for (let i = 0; i < arr2.length; i++) {
						for (let j = 0; j < arr1.length; j++) {
							if (arr1[j] === arr2[i]) {
								newArr.push(arr1[j]);
							}
						}
					}
					return newArr;
				}
			},
			aaaa(item) {
				
				let shuchu = ''
				if (item.answer == item.user_answer) {
					shuchu = {
						jg: 'yes',
						keys: 'succoption_key'
					}
				} else {
					shuchu = {
						jg: 'no',
						keys: 'erroroption_key'
					}
				}
				return shuchu
			},
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.analysis {
		font-size: 16px;
		margin-bottom: 40px;

		.analysis_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			height: 65px;
			color:#242121;

			.btns {
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			.btn {
				display: flex;
				align-items: center;
				margin-right: 15px;
				cursor: pointer;

				img {
					margin-right: 10px;
				}
			}
		}

		.zhankai {
			background-color: #f5f5f5;
			color: #666;
			font-size: 16px;
			overflow: hidden;
		}

		.analysis_content {
			padding: 20px;
			border-left: 1px solid #eee;
			border-right: 1px solid #eee;
		}

		.answer-note {
			margin-top: 0;
			border: 1px solid #f5f5f5;
			padding: 30px;
			border-top: none;
		

		}

	}

	.result_xmp {
		font-size: 16px;
		line-height: 1.8;
		margin-bottom: 20px;
			color: #1e1c1c;;
		
	}

	.option {
		padding: 15px;
		font-size: 16px;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.option_key {
			border-radius: 50%;
			height: 30px;
			width: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #999;
			color: #999
		}

		.erroption_key {
			border: 1px solid #ff6c6c !important;
			color: #ff6c6c !important;
		}

		.succoption_key {
			border: 1px solid#10aeff !important;
			color: #10aeff !important;
		}


		.sueroption_key {
			/* 渐变 */
			color: #ff6c6c;
			// border: none;
			// background: linear-gradient(to right, #ff6c6c 0%, #ff6c6c 50%, #10aeff 51%, #10aeff 100%);
			border-left: 1px solid #ff6c6c;
			border-top: 1px solid #ff6c6c;
			border-bottom: 1px solid #10aeff;
			border-right: 1px solid #10aeff;

		}

		.option_name {
			margin-left: 10px;
			color: #000;
		}
	}

	.erroption_name {
		color: #ff6c6c !important;
		
	}

	.succoption_name {
		color: #10aeff !important;
	}
</style>
